/**
 * What changed between two texts, said simply: the part that went in and the part that came out, with what they share
 * at the start and end left alone ("Added: ', with home delivery'"). Not a full diff: one edit, described, which is
 * what a small fix is.
 */
export function textChange(before: string, after: string): { removed: string; added: string } | null {
  if (before === after) return null;
  let start = 0;
  while (start < before.length && start < after.length && before[start] === after[start]) start++;
  let endBefore = before.length;
  let endAfter = after.length;
  while (endBefore > start && endAfter > start && before[endBefore - 1] === after[endAfter - 1]) {
    endBefore--;
    endAfter--;
  }
  return { removed: before.slice(start, endBefore), added: after.slice(start, endAfter) };
}

/** "Added: “, with home delivery”", "Removed: “typo”", or "Changed: “a” → “b”". */
export function describeChange(before: string, after: string): string | null {
  const change = textChange(before, after);
  if (!change) return null;
  const { removed, added } = change;
  if (!removed) return `Added: “${added}”`;
  if (!added) return `Removed: “${removed}”`;
  return `Changed: “${removed}” → “${added}”`;
}
